export default __webpack_public_path__ + "static/media/1.eaa4c5f5.jpg";